import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localUa from '@angular/common/locales/ru-UA';
import localUaExtra from '@angular/common/locales/extra/ru-UA';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
// import { ServiceWorkerModule } from '@angular/service-worker';

import { MaterialModule } from './material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { TableModule } from 'primeng/table';
import { GrowlModule } from 'primeng/growl';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { TreeModule } from 'primeng/tree';
import { DropdownModule } from 'primeng/dropdown';
import { SliderModule } from 'primeng/slider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService } from 'primeng/components/common/messageservice';
import 'leaflet';

import {
  AutheticationService,
  Client,
  CommonService,
  ControlMenuComponent,
  DriverService,
  ErrorMessageComponent,
  EventMessageComponent,
  HistoryService,
  ModalCloseComponent,
  ShowImageDialogComponent,
  NotFoundComponent,
  ProductsService,
  PassengerAppService,
  ProductsVisibilityPermissionsService,
  UsersService,
  ServiceConfService,
  VehicleManageService,
  ServiceTaxiService,
  StateService,
  ThemeSettingsService,
  ToolbarComponent,
  VehicleService,
  WsService,
  SettingsService,
  AddSummDriverDialogComponent,
  MinusSummDriverDialogComponent,
  UpdateDataService,
  RoutingMachineService,
  CustomTranslationService
} from './shared/index';

import { AuthentificationComponent } from './authentification/authentification.component';
import { AutheticationGuard } from './authetication.guard';
import { UiSettingComponent } from './ui-setting/ui-setting.component';
import { ServiceConfEditComponent } from './service-conf-edit/service-conf-edit.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatIconRegistry, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DashboardModule } from './dashboard/dashboard.module';
import { DashboardDriversBlockComponent } from './dashboard/dashboard-drivers-block/dashboard-drivers-block.component';
import { OperatorVehiclesComponent } from './operator-vehicles/operator-vehicles.component';
import { OrderService } from './shared/services/order.service';
import { OrderFormDriverCompleteComponent } from './dashboard/order-form-driver-complete/order-form-driver-complete.component';
import { OrderStoryDialogComponent } from './shared/components/order-story-dialog/order-story-dialog.component';
import { SharedModule } from './shared/shared.module';
import { UsersModule } from './users/users.module';
import { SentryInterceptor } from '@app/shared/Intercepters/sentry.interceptor';
import { RavenErrorHandler } from './raven-handler';
import { environment } from 'environments/environment';
import { AuthErrorInterceptor } from '@app/shared/Intercepters/auth-error.interceptor';
import { FeatureService } from '@app/shared/services/feature.service';
import { NotificationService } from '@app/shared/services/notification.service';
import { DriverTariffsModule } from '@app/driver-tariffs/driver-tariffs.module';
import { CacheService } from '@app/shared/services/cache.service';
import { ServerSelectInterceptor } from '@app/shared/Intercepters/server-select.interceptor';
import { PingService } from '@app/shared/services/ping.service';
import { XlsFormatService } from '@app/shared/services/xls-format.service';
import { PhoneReportsModule } from './phone-reports/phone-reports.module';
import { TimezoneService } from '@app/shared/services/timezone.service';
import { PassengersModule } from './passengers/passengers.module';
import { CookieService } from 'ngx-cookie-service';
import { RedmineReportsComponent } from './redmine-reports/redmine-reports.component';
import { TranslateLSLoader } from './utils/translate-ls-loader';
import { NoAuthGuard } from './no-auth.guard';
import { CustomTranslationDialogComponent } from './shared/components/custom-translation-dialog/custom-translation-dialog.component';

registerLocaleData(localeRu, 'ru', localeRuExtra);
registerLocaleData(localUa, 'ua', localUaExtra);

// import { WorkerAppModule } from '@angular/platform-webworker';

const { version } = require('../../package.json');

// Raven
//   .config('https://34025d6bb7404028bbf1d51ec384f6f8@crash.analytics.megakit.pro/6', {
//     release: version,
//     environment: environment.production ? 'production' : 'test'
//   })
//   .install();

@NgModule({
  declarations: [
    AppComponent,
    ToolbarComponent,
    ControlMenuComponent,
    NotFoundComponent,
    AuthentificationComponent,
    EventMessageComponent,
    ErrorMessageComponent,
    ModalCloseComponent,
    ShowImageDialogComponent,
    UiSettingComponent,
    ServiceConfEditComponent,
    DashboardDriversBlockComponent,
    AddSummDriverDialogComponent,
    MinusSummDriverDialogComponent,
    OperatorVehiclesComponent,
    OrderFormDriverCompleteComponent,
    OrderStoryDialogComponent,
    RedmineReportsComponent,
    CustomTranslationDialogComponent
  ],
  imports: [
    BrowserModule,
    // WorkerAppModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NoopAnimationsModule,
    HttpClientModule,
    // ServiceWorkerModule.register( '/taxis/ngsw-worker.js', { enabled: environment.production } ),
    MaterialModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, Client]
      }
    }),
    AppRoutingModule,
    DashboardModule,
    TableModule,
    GrowlModule,
    ButtonModule,
    CheckboxModule,
    TreeModule,
    DropdownModule,
    ConfirmDialogModule,
    SliderModule,
    RadioButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    UsersModule,
    ConfirmDialogModule,
    DriverTariffsModule,
    SharedModule,
    PhoneReportsModule,
    PassengersModule
  ],
  entryComponents: [
    EventMessageComponent,
    ErrorMessageComponent,
    OrderFormDriverCompleteComponent,
    ModalCloseComponent,
    ShowImageDialogComponent,
    DashboardDriversBlockComponent,
    AddSummDriverDialogComponent,
    MinusSummDriverDialogComponent,
    OrderStoryDialogComponent,
    CustomTranslationDialogComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ServerSelectInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SentryInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    ThemeSettingsService,
    AutheticationService,
    WsService,
    SettingsService,
    ProductsService,
    PassengerAppService,
    ProductsVisibilityPermissionsService,
    UsersService,
    ServiceTaxiService,
    StateService,
    AutheticationGuard,
    NoAuthGuard,
    ConfirmationService,
    MessageService,
    ServiceConfService,
    VehicleManageService,
    CommonService,
    DriverService,
    VehicleService,
    Client,
    HistoryService,
    UpdateDataService,
    OrderService,
    RoutingMachineService,
    FeatureService,
    NotificationService,
    XlsFormatService,
    CacheService,
    PingService,
    TimezoneService,
    CookieService,
    CustomTranslationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer, client: Client) {
    const icons = [
      'operator',
      'app',
      'order',
      'preOrder',
      'cash',
      'cashless',
      'assigned',
      'notAssigned',
      'progress',
      'waiting',
      'reserved',
      'phoneClient',
      'assign',
      'd-unlock',
      'd-lock',
      'l-reserve',
      'receipt',
      'driver-tariffs',
      'magnet',
      'logist',
      'arrived',
      'pickup',
      'temporary_tariffs',
      'fare_tariff',
      'phone_payments'
    ];
    icons.map(icon => {
      iconRegistry.addSvgIcon(icon, sanitizer.bypassSecurityTrustResourceUrl(`${client.getImgsUrl()}${icon}.svg`));
    });
  }
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateLSLoader(http);
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts